// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"ru-z","imageAndVideoCount":"su-z","imageAndVideoContainer":"tu-z","viewAllReviews":"uu-z"};